export const formFields = {
  FORMAT: {
    label: 'Download Format',
    description: 'Preferred file format for exports.',
    input: {}
  },
  DECIMALS: {
    label: 'Decimals in lists',
    description: 'Decimals places to display in lists.'
  }
}
